import { useModel as _useModel, mergeModels as _mergeModels, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList } from "vue"

import {computed, getCurrentInstance, ref} from 'vue';
import SvgIcon from "~/chat/vue/misc/SvgIcon.vue";
import {RATE_VALUE_BAD, RATE_VALUE_GOOD} from "~/chat/ts/data/ISiteParams";


const __default__ = {
    name: "ReviewValue"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: /*@__PURE__*/_mergeModels({
    system: {},
    modelIsListening: { type: Boolean }
  }, {
    "modelValue": {},
    "modelModifiers": {},
  }),
  emits: ["update:modelValue"],
  setup(__props: any) {

let props = __props

let model = _useModel<string>(__props, "modelValue");

let temporaryValue = ref<string>();

let instance = getCurrentInstance().proxy;

let editable = computed(() => {
    return !!props.modelIsListening;
});

let systemId = computed(() => {
    if (props.system != null) {
        return props.system;
    }
    if (model.value && model.value.indexOf("/") > -1) {
        return 5;
    }
    return 2;
});

let numericValue = computed(() => {
    if (valueForDisplay.value) {
        let numbers = valueForDisplay.value.split("/");
        if (numbers.length == 2) {
            return parseInt(numbers[0]) / parseInt(numbers[1]);
        }
    }
    return null;
});

function setTemporaryValue(value: string) {
    if (editable.value) {
        temporaryValue.value = value;
    }
}

function unsetTemporaryValue() {
    temporaryValue.value = null;
}

function setValue(value: string) {
    if (editable.value) {
        model.value = value;
    }
}

let valueForDisplay = computed(() => {
    return temporaryValue.value ? temporaryValue.value : model.value;
});

let isGood = computed(() => {
    return valueForDisplay.value == RATE_VALUE_GOOD;
});

let isBad = computed(() => {
    return valueForDisplay.value == RATE_VALUE_BAD;
});


return (_ctx: any,_cache: any) => {
  const _directive_on_native = _resolveDirective("on-native")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['review-value', _unref(editable) ? 'editable' : null])
  }, [
    (_unref(systemId) === 2)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _withDirectives(_createVNode(SvgIcon, {
            class: _normalizeClass({
                    good: true,
                    value: true,
                    selected: _unref(isGood)
                }),
            "icon-name": "thumbs-up",
            "icon-style": "solid"
          }, null, 8, ["class"]), [
            [_directive_on_native, () => setTemporaryValue('good'), "mouseover"],
            [_directive_on_native, unsetTemporaryValue, "mouseout"],
            [_directive_on_native, () => setValue('good'), "click"]
          ]),
          _withDirectives(_createVNode(SvgIcon, {
            class: _normalizeClass({
                    bad: true,
                    value: true,
                    selected: _unref(isBad),
                    'thumb-down': true
                }),
            "icon-name": "thumbs-up",
            "icon-style": "solid"
          }, null, 8, ["class"]), [
            [_directive_on_native, () => setTemporaryValue('bad'), "mouseover"],
            [_directive_on_native, () => unsetTemporaryValue, "mouseout"],
            [_directive_on_native, () => setValue('bad'), "click"]
          ])
        ], 64))
      : (_unref(systemId) === 5)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, _renderList([1,2,3,4,5], (i) => {
            return _withDirectives(_createVNode(SvgIcon, {
              key: i,
              class: _normalizeClass({
                        star: true,
                        value: true,
                        selected: (i/5 <= _unref(numericValue))
                    }),
              "icon-name": "star",
              "icon-style": "solid"
            }, null, 8, ["class"]), [
              [_directive_on_native, () => setTemporaryValue(i + '/5'), "mouseover"],
              [_directive_on_native, unsetTemporaryValue, "mouseout"],
              [_directive_on_native, () => setValue(i + '/5'), "click"]
            ])
          }), 64))
        : _createCommentVNode("", true)
  ], 2))
}
}

})